// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fPka","footer":"styles_footer__1mcsu","passCodeTooltip":"styles_passCodeTooltip__Nhjcg"};